import { usePublicFeatureFlags } from '@/shared/api/featureFlagsQueries'

export function useListingFeatureFlag(): { enabled: boolean; isLoading: boolean } {
  const flagsQuery = usePublicFeatureFlags()
  return {
    enabled: flagsQuery.data?.find((row) => row.module_name === 'listing')?.enabled === true,
    isLoading: flagsQuery.isPending,
  }
}

export function useListingEnabled(): boolean {
  return useListingFeatureFlag().enabled
}
